import { api } from "@/lib/api";

/**
 * Thin helpers around the analytics admin endpoints.
 * The shared `api` axios instance auto-attaches the admin JWT.
 * Each helper returns response.data.
 */

export async function getOverview(days = 30) {
  const { data } = await api.get("/analytics/overview", { params: { days } });
  return data;
}

export async function getPages(days = 30) {
  const { data } = await api.get("/analytics/pages", { params: { days } });
  return data;
}

export async function getVisitors(days = 30, limit = 200) {
  const { data } = await api.get("/analytics/visitors", { params: { days, limit } });
  return data;
}

export async function getHeatmap(path, days = 30, kind = "all") {
  const { data } = await api.get("/analytics/heatmap", { params: { path, days, kind } });
  return data;
}

export async function getSlides(days = 30) {
  const { data } = await api.get("/analytics/slides", { params: { days } });
  return data;
}
